function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_722_9268)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 27.5032L15.2929 28.2103L16 28.9174L16.7071 28.2103L16 27.5032ZM31.0849 12.4183L31.7921 13.1254L32.4992 12.4183L31.7921 11.7112L31.0849 12.4183ZM24.62 5.9533L25.3271 5.24619L25.0342 4.9533L24.62 4.9533L24.62 5.9533ZM7.38003 5.9533L7.38003 4.9533L6.96582 4.9533L6.67293 5.24619L7.38003 5.9533ZM0.915056 12.4183L0.20795 11.7112L-0.499157 12.4183L0.20795 13.1254L0.915056 12.4183ZM9.53502 12.4183L8.58634 12.7345L8.59949 12.774L8.61588 12.8122L9.53502 12.4183ZM16 5.9533L16.7071 5.24619C16.3166 4.85566 15.6834 4.85566 15.2929 5.24619L16 5.9533ZM22.465 12.4183L23.3841 12.8122L23.4005 12.774L23.4137 12.7345L22.465 12.4183ZM16.7071 28.2103L31.7921 13.1254L30.3778 11.7112L15.2929 26.7961L16.7071 28.2103ZM31.7921 11.7112L25.3271 5.24619L23.9129 6.6604L30.3778 13.1254L31.7921 11.7112ZM24.62 4.9533H7.38003L7.38003 6.9533H24.62L24.62 4.9533ZM6.67293 5.24619L0.20795 11.7112L1.62216 13.1254L8.08714 6.6604L6.67293 5.24619ZM0.20795 13.1254L15.2929 28.2103L16.7071 26.7961L1.62216 11.7112L0.20795 13.1254ZM31.0849 11.4183H0.915057L0.915057 13.4183H31.0849L31.0849 11.4183ZM10.2421 13.1254L16.7071 6.6604L15.2929 5.24619L8.82792 11.7112L10.2421 13.1254ZM15.2929 6.6604L21.7579 13.1254L23.1721 11.7112L16.7071 5.24619L15.2929 6.6604ZM8.61588 12.8122L15.0809 27.8971L16.9191 27.1093L10.4542 12.0244L8.61588 12.8122ZM21.5458 12.0244L15.0809 27.1093L16.9191 27.8971L23.3841 12.8122L21.5458 12.0244ZM23.6713 5.63707L21.5163 12.102L23.4137 12.7345L25.5687 6.26952L23.6713 5.63707ZM6.43135 6.26952L8.58634 12.7345L10.4837 12.102L8.32872 5.63707L6.43135 6.26952Z",
  fill: "currentcolor"
}));

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_722_9268",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.f69a0637.svg";
export { ForwardRef as ReactComponent };